/*
 *  TTTech nerve-management-system
 *  Copyright(c) 2022. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */

import BaseApiService from './base.api-service';

const ENDPOINTS = {
  LOGIN: 'auth/login',
  VALIDATE_MFA: 'auth/mfa/validate',
  LOGOUT: 'auth/logout',
};

class AuthApiService extends BaseApiService {
  login(credentials) {
    return this.post(ENDPOINTS.LOGIN, credentials);
  }

  validateMFA(params) {
    return this.post(ENDPOINTS.VALIDATE_MFA, params);
  }

  logout() {
    return this.get(ENDPOINTS.LOGOUT, {
      authRequired: true,
    });
  }
}

export default new AuthApiService();
